// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate, useLocation } from "react-router-dom";
// import { verifyauthCheck, getSubscriptionRevenueList } from "../handlers/adminApi";
// import { formatPriceInUSD } from "../handlers/helpers";
// import _ from "lodash";
// import { DotLoader } from "react-spinners"; // Import the loader
// import { faDownload } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import axios from 'axios';

// function Revenue() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [currentData, setSubscriptionRevenue] = useState([]); // Display data per page
//   const [loading, setLoading] = useState(true); // State to track loading
//   const [totalPages, setTotalPages] = useState(1); // Track total number of pages
//   const navigate = useNavigate(); // Hook for navigation
//   const location = useLocation();

//   const tipsPerPage = 8; // Set to 8 for displaying 8 results per page
//   const hasRun = useRef(false);

//   // Check authentication
//   const authCheck = async () => {
//     var resp = await verifyauthCheck();
//     if (resp != null) {
//       if (resp.status === true) {
//         navigate(location.pathname, {
//           state: { ...location.state, userData: resp.userData }
//         });
//       } else {
//         navigate("/");
//       }
//     }
//   };

//   // Fetch subscription revenue data for a specific page
//   const getSubscriptionRevenue = async (page) => {
//     setLoading(true);
//     try {
//       const resp = await getSubscriptionRevenueList({ page: page.toString(), limit: tipsPerPage });
//       const pageData = _.get(resp, 'data', []);

//       // Ensure valid data
//       if (!Array.isArray(pageData)) {
//         console.error('Invalid data format:', pageData);
//         return;
//       }

//       // Sort results by created_at (newest first)
//       const sortedResults = pageData.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

//       // Update the state with the sorted results
//       setSubscriptionRevenue(sortedResults);
//       setTotalPages(Math.ceil((resp.total || 0) / tipsPerPage)); // Safeguard totalPages calculation

//     } catch (error) {
//       console.error("Error fetching subscription revenue:", error);
//     } finally {
//       setLoading(false); // Set loading to false once the data is fetched
//     }
//   };

//   useEffect(() => {
//     if (!hasRun.current) {
//       hasRun.current = true;
//       authCheck();
//     }
//     getSubscriptionRevenue(currentPage); // Fetch the data when the page changes or component mounts
//   }, [currentPage]); // Fetch data whenever the page changes

//   // Handle page change
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Handle CSV export
//   const handleExportClick = async () => {
//     try {
//       console.log('Initiating export...');
//       const response = await axios.get(`${process.env.REACT_APP_API_HOSTNAME}/admin/export-subscription-revenue`, {
//         responseType: 'json',
//       });

//       if (response.status === 200 && response.data) {
//         const csvString = response.data.data;
//         const rows = csvString.split('\n');
//         let csvContent = 'revenue_id,user_name,user_email,user_id,plan_name,plan_price,created_at,plan_expiry,status\n';

//         rows.slice(1).forEach(row => {
//           const columns = row.split(',');
//           const createdAt = new Date(columns[5] * 1000).toLocaleDateString('en-US', {
//             year: 'numeric', month: 'short', day: 'numeric'
//           });

//           const planExpiry = new Date(columns[6] * 1000).toLocaleDateString('en-US', {
//             year: 'numeric', month: 'short', day: 'numeric'
//           });

//           csvContent += `${columns[0]},${columns[1]},${columns[2]},${columns[3]},${columns[4]},${createdAt},${planExpiry},${columns[7]}\n`;
//         });

//         const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', 'Revenue_list.csv');
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         alert('Download successfully');
//       } else {
//         throw new Error('Failed to export Revenue list: Invalid response');
//       }
//     } catch (error) {
//       console.error('Error exporting Revenue list:', error);
//       alert('There was an error exporting the Revenue list. Please check the console for more details.');
//     }
//   };

//   return (
//     <div className="right" style={{ overflow: "hidden" }}>
//       <div className="title">
//         <h2>Revenue</h2>
//       </div>
//       {loading ? (
//         <div className="loader-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginLeft: '450px', marginTop: '90px' }}>
//           <DotLoader size={50} color="#F7812A" />
//         </div>
//       ) : (
//         <div className="table">
//           <div className="export-btn-container">
//             <a onClick={handleExportClick} className="export-btn">
//               <FontAwesomeIcon icon={faDownload} />
//               Export Revenue list
//             </a>
//           </div>
//           <table>
//               <tr>
//                 <th>User Name</th>
//                 <th>Email</th>
//                 <th>Plan</th>
//                 <th>Purchase date</th>
//                 <th>Plan Price</th>
//                 <th>Date of Expiry</th>
//               </tr>
         
//               {currentData.length > 0 ? (
//                 currentData.map((entry, index) => (
//                   <tr key={index}>
//                     <td>{entry.user_name}</td>
//                     <td>{entry.user_email}</td>
//                     <td>{entry.plan_name}</td>
//                     <td>{new Date(entry.created_at * 1000).toLocaleDateString()}</td>
//                     <td>{formatPriceInUSD(entry.plan_price)}</td>
//                     <td>{new Date(entry.plan_expiry * 1000).toLocaleDateString()}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr><td colSpan="5">No data available</td></tr>
//               )}
//           </table>

//           <hr className="horizontal-line" />

//           <div className="pagination">
//             {/* Correct the range for "Showing X to Y entries" */}
//             <span>
//               Showing  {Math.min(currentPage * tipsPerPage, currentData.length)} of {currentData.length} entries
//             </span>
//             <div className="pagination-buttons">
//               <button
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//               >
//                 Previous
//               </button>

//               {/* Generate page number buttons */}
//               {[...Array(totalPages)].map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => handlePageChange(index + 1)}
//                   className={currentPage === index + 1 ? 'active' : ''}
//                 >
//                   {index + 1}  {/* Display page number */}
//                 </button>
//               ))}

//               <button
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//               >
//                 Next
//               </button>
//             </div>
//           </div>

//         </div>
//       )}
//     </div>
//   );
// }

// export default Revenue;

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import '../StyledComponents/Styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { verifyauthCheck, getSubscriptionRevenueList } from "../handlers/adminApi";
import { formatPriceInUSD } from "../handlers/helpers";
import _ from "lodash";
import { DotLoader } from "react-spinners";
import axios from 'axios';

function Revenue() {
    const [revenues, setRevenues] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [revenuesPerPage] = useState(8);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const hasRun = useRef(false);

    const totalPages = Math.ceil(revenues.length / revenuesPerPage);
    const indexOfLastRevenue = currentPage * revenuesPerPage;
    const indexOfFirstRevenue = indexOfLastRevenue - revenuesPerPage;
    const currentRevenues = revenues.slice(indexOfFirstRevenue, indexOfLastRevenue);

    // Auth check
    const authCheck = async () => {
        var resp = await verifyauthCheck();
        if (resp != null) {
            if (resp.status === true) {
                navigate(location.pathname, {
                    state: { ...location.state, userData: resp.userData }
                });
            } else {
                navigate("/");
            }
        }
    };

    // Fetch revenue records
    const getRevenuesRecord = async () => {
        setLoading(true);
        try {
            const response = await getSubscriptionRevenueList();
            const fetchedRevenues = _.get(response, 'data', []);

            const sortedRevenues = fetchedRevenues.sort(
                (a, b) => b.created_at - a.created_at
            );

            setRevenues(sortedRevenues);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching revenues:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!hasRun.current) {
            hasRun.current = true;
            authCheck();
            getRevenuesRecord();
        }
    }, []);

    // Handle CSV export
    const handleExportClick = async () => {
        try {
            console.log('Initiating export...');
            const response = await axios.get(
                `${process.env.REACT_APP_API_HOSTNAME}/admin/export-subscription-revenue`,
                { responseType: 'json' }
            );

            if (response.status === 200 && response.data) {
                const csvString = response.data.data;
                const rows = csvString.split('\n');
                let csvContent =
                    'Revenue ID,User Name,Email,User ID,Plan Name,Plan Price,Purchase Date,Plan Expiry,Status\n';

                rows.slice(1).forEach((row) => {
                    const columns = row.split(',');
                    const createdAt = new Date(columns[5] * 1000).toLocaleDateString('en-US', {
                        year: 'numeric', month: 'short', day: 'numeric'
                    });
                    const planExpiry = new Date(columns[6] * 1000).toLocaleDateString('en-US', {
                        year: 'numeric', month: 'short', day: 'numeric'
                    });

                    csvContent += `${columns[0]},${columns[1]},${columns[2]},${columns[3]},${columns[4]},${columns[5]},${createdAt},${planExpiry},${columns[7]}\n`;
                });

                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Revenue_list.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                alert('Download successfully');
            } else {
                throw new Error('Failed to export Revenue list: Invalid response');
            }
        } catch (error) {
            console.error('Error exporting Revenue list:', error);
            alert('There was an error exporting the Revenue list. Please check the console for more details.');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="right">
            {loading ? (
                <div className="loader-container" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    marginLeft: '450px',
                    marginTop: '90px'
                }}>
                    <DotLoader color="#F7812A" loading={loading} size={60} />
                </div>
            ) : (
                <>
                    <div className="title">
                        <h2>Revenue</h2>
                    </div>
                    <div className="table">
                        <div className="export-btn-container">
                            <a onClick={handleExportClick} className="export-btn">
                                <FontAwesomeIcon icon={faDownload} />
                                Export Revenue list
                            </a>
                        </div>
                        <table>
                            <tr>
                                <th>User Name</th>
                                <th>Email</th>
                                <th>Plan</th>
                                <th>Purchase Date</th>
                                <th>Plan Price</th>
                                <th>Date of Expiry</th>
                            </tr>

                            {currentRevenues.map((entry, index) => (
                                <tr key={index}>
                                    <td>{entry.user_name}</td>
                                    <td>{entry.user_email}</td>
                                    <td>{entry.plan_name}</td>
                                    <td>{new Date(entry.created_at * 1000).toLocaleDateString()}</td>
                                    <td>{formatPriceInUSD(entry.plan_price)}</td>
                                    <td>{new Date(entry.plan_expiry * 1000).toLocaleDateString()}</td>
                                </tr>
                            ))}
                        </table>
                        <hr className="horizontal-line" />
                        <div className="pagination">
                            <span>
                                Showing {Math.min(indexOfLastRevenue, revenues.length)} of {revenues.length} entries
                            </span>
                            <div className="pagination-buttons">
                                {[...Array(totalPages)].map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => handlePageChange(index + 1)}
                                        className={currentPage === index + 1 ? 'active' : ''}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                                <button
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default Revenue;
